import type { ReactNode } from "react";
import {
  Alert,
  type AlertColor,
  AlertDescription,
  AlertTitle,
} from "@volca/ui/components/ui/alert";

/**
 * A notice under an agent's header about what the page is showing, and the
 * one or two things to do about it: a draft waiting to publish, a newer run
 * of the period, a run that is not the period's result. The icon and the
 * colour say which; the actions sit under the words, so two always fit.
 */
export const PageNotice = ({
  color,
  icon,
  title,
  children,
  actions,
}: {
  color: AlertColor;
  icon: ReactNode;
  title: ReactNode;
  /** What it means, in a sentence. */
  children?: ReactNode;
  actions?: ReactNode;
}) => (
  <Alert color={color} className="px-3.5 py-3">
    {icon}
    <AlertTitle>{title}</AlertTitle>
    {children && <AlertDescription>{children}</AlertDescription>}
    {actions && (
      <div className="col-start-2 mt-2 flex flex-wrap gap-2">{actions}</div>
    )}
  </Alert>
);
